import * as React from 'react';
import {  Grid, Typography } from "@material-ui/core";
import Chart from "react-apexcharts";
import useMetric from "../../../lib/hooks/useMetric";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import {useParams} from "react-router";
export default function OpensByDay() {
   const {campaignId} = useParams();
   const {isLoading, isRefetching, data, refetch} = useMetric('opens_by_day', 'campaign', campaignId);
  return (
    <>
      <Grid item xs={6}>
        <Typography variant={'h2'} color={'primary'}>
          Opens By Day
        </Typography>
         {isLoading || isRefetching && <ProgressBar style={{margin:25}}/>}
         {!(isLoading || isRefetching) && data && <Chart
            options={{
               colors: ['#546E7A', '#D9534F', '#FF9800'],
               chart: {
                  type: 'line',
               },
               plotOptions: {
                  bar: {
                     horizontal: false,
                     columnWidth: '55%',
                     endingShape: 'rounded'
                  },
               },
               animations: {
                  enabled: true,
                  easing: 'linear',
                  dynamicAnimation: {
                     speed: 1000
                  }
               },
               stroke: {
                  curve: 'smooth'
               },
               dataLabels: {
                  enabled: false
               },
               xaxis: {
                  categories: data.metric.labels ?? [],
                  labels: {
                     show: true
                  }
               }
            }}
            series={[{
               name: 'Opens',
               data: data.metric.opens ?? []
            }, {
               name: 'Clicks',
               data: data.metric.clicks ?? []
            }
            ]}
            type="line"
            height={250}
         />}
      </Grid>
    </>
  );
}
